import { queryAll } from '../utils/utils.js';


function setDropdownExpanded( dropdown, isOpen ) {
	const togglebtn = dropdown.querySelector( '.dropdown-toggle' );
	if ( togglebtn ) {
		togglebtn.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
	}
}

function initDropdownAria( dropdown ) {
	const togglebtn = dropdown.querySelector( '.dropdown-toggle' );
	const dropdownMenu = dropdown.querySelector( '.dropdown-menu' );

	if ( ! togglebtn || ! dropdownMenu ) {
		return;
	}

	if ( ! togglebtn.hasAttribute( 'aria-expanded' ) ) {
		togglebtn.setAttribute( 'aria-expanded', 'false' );
	}
	if ( ! togglebtn.hasAttribute( 'aria-haspopup' ) ) {
		togglebtn.setAttribute( 'aria-haspopup', 'true' );
	}
	if ( dropdownMenu.id && ! togglebtn.hasAttribute( 'aria-controls' ) ) {
		togglebtn.setAttribute( 'aria-controls', dropdownMenu.id );
	}

	const icon = togglebtn.querySelector( '.icon' );
	if ( icon && ! icon.hasAttribute( 'aria-hidden' ) ) {
		icon.setAttribute( 'aria-hidden', 'true' );
	}
}

function closeDropdown( dropdown ) {
	dropdown.classList.remove( 'open' );
	if ( dropdown.dropdownBackground && dropdown.dropdownHeight !== undefined ) {
		dropdown.dropdownBackground.style.height = dropdown.dropdownHeight + 'px';
	}
	document.removeEventListener( 'keydown', dropdown.handleKeyDown );
	dropdown.style.zIndex = 5;
	setDropdownExpanded( dropdown, false );
}


export class DropDownMenus {

    constructor() {

    }

	/**
	 * Keep toggle aria-expanded and menu aria-hidden aligned with visibility for assistive tech.
	 */
	syncDropdownAccessibility(dropdown, isOpen) {
		const togglebtn = dropdown.querySelector('.dropdown-toggle');
		const menu = dropdown.dropdownMenu || dropdown.querySelector('.dropdown-menu');
		if (togglebtn) {
			togglebtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		}
		if (menu) {
			menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
		}
	}

	init = function() {

		queryAll('.dropdown').forEach((dropdown) => {
			const allowMultiple = dropdown.dataset.allowMultiple;
			const showValueLabel = dropdown.dataset.showValueLabel;
			const togglebtn = dropdown.querySelector('.dropdown-toggle');

			if (!dropdown.dataset.inited) {
				initDropdownAria( dropdown );
				dropdown.setAttribute('value', '');
				if (showValueLabel ) {
					const labelContainer = document.createElement('div');
					labelContainer.classList.add('label-container');

					const label = document.createElement('h5');
					label.innerHTML = togglebtn.innerHTML;
					label.classList.add('label');
					labelContainer.appendChild(label);

					const labelValue = document.createElement('h6');
					labelValue.classList.add('label-value');
					labelContainer.appendChild(labelValue);

					const icon = label.querySelector('i');
					togglebtn.innerHTML = '';
					togglebtn.appendChild(labelContainer);
					if (icon) {
						icon.setAttribute('aria-hidden', 'true');
						togglebtn.appendChild(icon);
					}
				}


				const dropdownHeight = dropdown.querySelector('.dropdown-background').getBoundingClientRect().height;
				const dropdownMenu = dropdown.querySelector('.dropdown-menu');
				const dropdownBackground = dropdown.querySelector('.dropdown-background');

				dropdown.dropdownHeight = dropdownHeight;
				dropdown.dropdownMenu = dropdownMenu;
				dropdown.dropdownBackground = dropdownBackground;

				if (togglebtn && dropdownMenu) {
					if (!togglebtn.hasAttribute('aria-haspopup')) {
						togglebtn.setAttribute('aria-haspopup', 'true');
					}
					if (dropdownMenu.id && !togglebtn.getAttribute('aria-controls')) {
						togglebtn.setAttribute('aria-controls', dropdownMenu.id);
					}
					togglebtn.querySelectorAll('i').forEach((iconEl) => {
						iconEl.setAttribute('aria-hidden', 'true');
					});
					this.syncDropdownAccessibility(dropdown, dropdown.classList.contains('open'));
				}

				// key events //
				dropdown.handleKeyDown = (e) => {
					if (e.key === 'Escape') {
						closeDropdown( dropdown );
					}
				};

				togglebtn.addEventListener('click', (e) => {
					e.stopPropagation();

					// collapse other dropdowns
					queryAll('.dropdown').forEach(( otherdropdowns ) => {
						if (otherdropdowns !== e.currentTarget.parentNode) {
							closeDropdown( otherdropdowns );
						}
					});

					dropdown.classList.toggle('open');
					const isOpen = dropdown.classList.contains('open');
					setDropdownExpanded( dropdown, isOpen );

					if (isOpen) {
						const dropdownMenuHeight = (dropdownMenu.getBoundingClientRect().y - dropdown.getBoundingClientRect().y) + dropdownMenu.getBoundingClientRect().height;
						dropdownBackground.style.height = dropdownMenuHeight + 'px';
						document.addEventListener('keydown', dropdown.handleKeyDown);
						dropdown.style.zIndex = 10;
					} else {
						dropdownBackground.style.height = dropdownHeight + 'px';
						document.removeEventListener('keydown', dropdown.handleKeyDown);
					}

					this.syncDropdownAccessibility(dropdown, dropdown.classList.contains('open'));

					// close menu when clicking outside
					document.addEventListener('click', (e) => {
						closeDropdown( dropdown );
					}, { once: true });

				});

				this.setChildListeners( dropdown );
				dropdown.dataset.inited = true;


				const scope = this;
				// listen for dom changes to .dropdown-menu
				const observer = new MutationObserver(function (mutations) {

					mutations.forEach(function (mutation) {
						if (mutation.type === 'childList' ) {
							scope.setChildListeners( dropdown );
							scope.checkValues( dropdown );
							// stop observing
							//observer.disconnect();
						}
					});
				});

				observer.observe( dropdown.querySelector('.dropdown-menu') , { childList: true, subtree: true });
			}
		});
	}

	checkValues = function ( dropdown ) {
		// console.log( 'checkValues', dropdown );
		let values = [];
		dropdown.querySelectorAll('.item').forEach((item, i) => {
			const isChecked = item.classList.contains('checked');
			const button = item.querySelector('a');
			const itemValue = (item.dataset.value) ? item.dataset.value : button.querySelector('span').innerHTML;

			if (isChecked) values.push(itemValue);

		});
		dropdown.dataset.value = values;
		dropdown.setAttribute('value', values.join(', '));

		const labelValue = dropdown.querySelector('.label-value');
		if (labelValue) labelValue.innerHTML = values.join(', ');

		if( values.length > 0 ) {
			dropdown.classList.add('has-value');
		} else {
			dropdown.classList.remove('has-value');
		}
	}

	setChildListeners = function ( dropdown ) {
		const scope = this;
		const allowMultiple = dropdown.dataset.allowMultiple;

		dropdown.querySelectorAll('.dropdown-menu .menu-item').forEach((item, i) => {

			const anchorLink = item.querySelector('a');
			if (anchorLink) {
				if (anchorLink.href) {
					item.dataset.href = anchorLink.href;
					anchorLink.removeAttribute('href');
				}
			}

			if (!item.dataset.hasListener) {
				
				item.addEventListener('click', (e) => {

					this.checkValues( dropdown );
					if (!allowMultiple) { 
						closeDropdown( dropdown );
					}

					if (item.classList.contains('icon-external') || item.classList.contains('icon-download')) {
						window.open(item.dataset.href, '_blank');
					} else {
						window.open(item.dataset.href, '_self');
					}
					
				} );

				

				item.dataset.hasListener = true;
			}
		});

	}
}
